export default __webpack_public_path__ + "static/media/popup_tos.a960ff45.png";